// extracted by mini-css-extract-plugin
export default {"root":"root__eXbFj","fadeInAnimation":"fadeInAnimation__FbTp2","heading":"heading__T5kGL","hideContent":"hideContent__bEBqj","fadeOutAnimation":"fadeOutAnimation__RLnyp"};